var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebflowLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#228BE6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "500px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 25 2 C 12.309288 2 2 12.309297 2 25 C 2 37.690703 12.309288 48 25 48 C 37.690712 48 48 37.690703 48 25 C 48 12.309297 37.690712 2 25 2 z M 25 4 C 36.609833 4 46 13.390175 46 25 C 46 36.609825 36.609833 46 25 46 C 13.390167 46 4 36.609825 4 25 C 4 13.390175 13.390167 4 25 4 z M 28.382812 17.044922 C 24.976813 17.044922 23.164078 19.45625 22.205078 22.03125 C 22.205078 22.03125 19.779984 28.314703 19.583984 28.845703 C 19.571984 28.348703 19.214844 22.101562 19.214844 22.101562 C 19.006844 18.960562 16.141312 17.054688 13.820312 17.054688 L 16.615234 34.099609 C 20.183234 34.087609 22.100469 31.674328 23.105469 29.111328 C 23.105469 29.111328 25.240984 23.568453 25.333984 23.314453 C 25.356984 23.556453 26.869141 34.099609 26.869141 34.099609 C 30.437141 34.099609 32.36625 31.836234 33.40625 29.365234 L 38.394531 17.044922 C 34.861531 17.044922 33.002922 19.45625 32.044922 22.03125 C 32.044922 22.03125 30.046484 28.291266 29.896484 28.822266 C 29.838484 28.291266 28.382812 17.044922 28.382812 17.044922 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflowLogoBlue);
export default __webpack_public_path__ + "static/media/webflow-logo-blue.b507e00a5744b35be5a40c9e8ef30335.svg";
export { ForwardRef as ReactComponent };